import { PortfolioRights, SlotsModuleRights } from '@orion-platform/core';

export const enum Plants {
  CTP = 'CTP',
  CZ05 = 'CZ05',
  FC07 = 'FC07',
  JUSDA = 'JUSDA',
  LS51 = 'LS51',
  MULTI = 'MULTI',
}

export enum StorageKeys {
  LANGUAGE = 'language',
}

export type KeyValue = {
  key: string;
  value: string;
};

export enum UserRoles {
  Orion_Administrator = 'Orion_Administrator',
  Orion_AI = 'Orion_AI',
  Orion_AI_Analyst = 'Orion_AI_Analyst',
  Orion_CTP = 'Orion_CTP',
  Orion_Finance_Accountant = 'Orion_Finance_Accountant',
  Orion_Finance_Analyst = 'Orion_Finance_Analyst',
  Orion_JUSDA = 'Orion_JUSDA',
  Orion_Logistics_Analyst = 'Orion_Logistics_Analyst',
  Orion_Logistics_Carrier = 'Orion_Logistics_Carrier',
  Orion_Logistics_Declarant = 'Orion_Logistics_Declarant',
  Orion_Logistics_Logistic = 'Orion_Logistics_Logistic',
  Orion_Logistics_Readonly = 'Orion_Logistics_Readonly',
  Orion_Logistics_Slot = 'Orion_Logistics_Slot',
  Orion_Logistics_Warehouse = 'Orion_Logistics_Warehouse',
  Orion_Multi = 'Orion_Multi',
  Orion_SCM_Analyst = 'Orion_SCM_Analyst',
  Orion_SCM_Buyer = 'Orion_SCM_Buyer',
  Orion_SCM_Customer = 'Orion_SCM_Customer',
  Orion_SCM_Customer_Commit = 'Orion_SCM_Customer_Commit',
  Orion_SCM_Engineering = 'Orion_SCM_Engineering',
  Orion_SCM_Master_Buyer = 'Orion_SCM_Master_Buyer',
  Orion_SCM_ReadOnly = 'Orion_SCM_ReadOnly',
  Orion_SCM_Sourcing = 'Orion_SCM_Sourcing',
  Orion_SCM_Supplier_BS = 'Orion_SCM_Supplier_BS',
  Orion_SCM_Supplier_Commit = 'Orion_SCM_Supplier_Commit',
  Orion_SCM_Supplier_No_Commit = 'Orion_SCM_Supplier_No_Commit',
  Orion_SCM_Supplier_ROP = 'Orion_SCM_Supplier_ROP',
  Orion_Warehouse_Analyst = 'Orion_Warehouse_Analyst',
}

export type ContactsPageRights = {
  canCreate?: boolean;
  canEdit?: boolean;
  canUpload?: boolean;
};

export type UserRights = {
  contactsPage?: ContactsPageRights;
  generateInstructions?: GenerateInstructionsPageRights;
  portfolioRights?: PortfolioRights;
  slotsCalendar?: SlotCalendarRights;
  slotsPage?: SlotsModuleRights;
  uploadDocumentsPage?: UploadDocumentsPageRights;
};

type GenerateInstructionsPageRights = {
  canGenerateInstructions?: boolean;
  documents?: UploadDocumentsRights;
};

type UploadDocumentsPageRights = {
  canGenerateInstructions?: boolean;
  canSearch?: boolean;
  documents?: UploadDocumentsRights;
};

type UploadDocumentsRights = {
  canDelete?: boolean;
  canDownload?: boolean;
  canUpload?: boolean;
};

export type SlotDocumentsRights = {
  canDelete?: boolean;
  canUpload?: boolean;
};

export type SlotShipmentsRights = {
  canCreate?: boolean;
  canDelete?: boolean;
};

export type SlotCalendarRights = {
  canDownload?: boolean;
};

export type PasteComputeInput = {
  clipboardText: string;
  event: HTMLInputElement;
  originValue: null | string | string[] | undefined;
};

export type PasteComputeResult = {
  /** Raw, unformatted text read from the clipboard. */
  clipboardText: string;
  newCursorPos: number;
  updatedValue: string;
};
